import {createClient} from '@sanity/client'

export const client = createClient({
    projectId: process.env.REACT_APP_API_KEY,
    dataset: 'production',
    useCdn: true, // set to `false` to bypass the edge cache
    apiVersion: '2023-09-20', // use current date (YYYY-MM-DD) to target the latest API version
    
  })